import React from 'react';
import styled from 'styled-components';
import { Linkedin, Mail } from 'lucide-react';

const FooterContainer = styled.footer`
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  padding: 4rem 2rem 2rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  margin-bottom: 3rem;
  text-align: center;
`;

const FooterLogo = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #3a5cf7;
  margin-bottom: 1rem;
`;

const FooterDescription = styled.p`
  color: #6b7280;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 2rem;
`;

const SocialLink = styled.a`
  color: #6b7280;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3a5cf7;
  }
`;

const FooterBottom = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
  text-align: center;
  color: #6b7280;
  font-size: 0.875rem;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>Rhinovate</FooterLogo>
        <FooterDescription>
          Revolutionary AI-powered 3D visualization for rhinoplasty, enhancing the surgeon and patient experience.
        </FooterDescription>
        <SocialLinks>
          <SocialLink href="https://www.linkedin.com/company/rhinovate/" target="_blank" rel="noopener noreferrer">
            <Linkedin size={20} />
          </SocialLink>
          <SocialLink href="mailto:deesha@rhinovate.ai">
            <Mail size={20} />
          </SocialLink>
        </SocialLinks>
      </FooterContent>
      
      <FooterBottom>
        © 2025 Rhinovate. All rights reserved.
      </FooterBottom>
    </FooterContainer>
  );
}

export default Footer;
